import { Button, Grid, TextField, Typography } from '@mui/material'
import moment from 'moment'
import React, { useState } from 'react'
import AnDateTimePicker from '../../../../components/DateTime/DateTimePicker'
import CustomSelect from './CustomSelect'
import AssessmentText from './AssessmentText'

const Wound = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} lg={6}>
        <Typography variant="title2">Wound Assessment</Typography>
      </Grid>
      <Grid item xs={12} lg={6}>
        <AnDateTimePicker
          date={moduleValues.dateTime}
          fullWidth
          size="small"
          onChange={(newDate) =>
            setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
          }
        />
      </Grid>
      <Grid item xs={12} lg={4}>
        <TextField
          value={moduleValues?.location ?? ''}
          label="Location"
          fullWidth
          onChange={(e) =>
            setModuleValues((prev) => ({ ...prev, location: e.target.value }))
          }
        />
      </Grid>
      <CustomSelect
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        label="Wound Type"
        options={[
          'Abrasion',
          'Laceration',
          'Incision',
          'Puncture',
          'Bite Wound',
          'Burn',
          'Other',
        ]}
      />
      <Grid item xs={12} lg={4}>
        <TextField
          value={moduleValues?.size ?? ''}
          label="Size"
          fullWidth
          onChange={(e) =>
            setModuleValues((prev) => ({ ...prev, size: e.target.value }))
          }
        />
      </Grid>
      <AssessmentText
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
      />
      <Grid item xs={12}>
        <Button
          variant="contained"
          fullWidth
          color="success"
          onClick={() => submitModule('Wound', moduleValues)}
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  )
}

export default Wound
